export const getIsOpen = (state) => state.alertOwner.isOpen
export const getNotification = (state) => state.alertOwner.notification
